<template>
	<BaseBadge badge-class="primary" class="applied-filter-badge">
		<div class="spacer">
			<span>{{ text }}</span>
			<button
					class="delete-button"
					type="button"
					@click="$emit('delete')"
			>
				<span class="sr-only">Filter wissen</span>
				<IconSvg icon="close" />
			</button>
		</div>
	</BaseBadge>
</template>

<script setup lang="ts">
	import BaseBadge from '~/components/generic/badge/BaseBadge.vue';
	import IconSvg from '~/components/generic/IconSvg.vue';

	defineProps({
		text: {
			type: String,
			required: true
		}
	});

	defineEmits(['delete']);
</script>

<style scoped>
	.applied-filter-badge {
		--badge-padding-x: .75rem;
		flex: 0 0 auto;
	}

	.spacer {
		display: flex;
	}

	.delete-button {
		cursor: pointer;
		border: none;
		background: none;
		flex: 0 0 auto;
		padding: 4px 6px 4px 6px;
		margin: -4px -12px -4px auto;
		color: inherit;
	}

	.delete-button:deep(svg) {
		--icon-size: 14px;
	}
</style>
